export default __webpack_public_path__ + "static/Primary-b45758abd1bf5d2e633e4c85f8b33c3b.png";